import React from "react";
import { Card, Form, Row, Col, Button, Image } from "react-bootstrap";
import { useUploadFile } from "../../../../../../api/fileUpload/fileUpload.hooks";

const MagnificentPunjabSection = ({ data, onUpdate }) => {
  const { upload, isLoading: isUploading } = useUploadFile();

  const handleChange = (field, value) => {
    onUpdate({
      ...data,
      [field]: value
    });
  };

  const handleFileUpload = async (field, file) => {
    try {
      const res = await upload(file);
      if (res?.url) {
        handleChange(field, res.url);
      }
    } catch (err) {
      console.error("File upload failed:", err);
    }
  };

  const handleEconomicImpactsChange = (index, field, value) => {
    const economicImpacts = [...data.economicImpacts];
    economicImpacts[index][field] = value;
    handleChange("economicImpacts", economicImpacts);
  };

  const handleAddEconomicImpact = () => {
    const economicImpacts = [...data.economicImpacts];
    economicImpacts.push({ title: "", description: "" });
    handleChange("economicImpacts", economicImpacts);
  };

  const handleRemoveEconomicImpact = (index) => {
    const economicImpacts = [...data.economicImpacts];
    economicImpacts.splice(index, 1);
    handleChange("economicImpacts", economicImpacts);
  };

  return (
    <Card className="mb-4 shadow">
      <Card.Header className="bg-neutral-gray text-dark d-flex justify-content-between align-items-center">
        <h5 className="mb-0 text-dark">Magnificent Punjab Section</h5>
        <Form.Check
          type="checkbox"
          label="Visible"
          checked={data.isVisible}
          onChange={(e) => handleChange('isVisible', e.target.checked)}
          className="mb-0"
        />
      </Card.Header>
      {data.isVisible && (
        <Card.Body>
          <Row>
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label>Heading</Form.Label>
                <Form.Control
                  type="text"
                  value={data.heading}
                  onChange={(e) => handleChange('heading', e.target.value)}
                  placeholder="Enter heading"
                />
              </Form.Group>
            </Col>
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label>Image</Form.Label>
                <Form.Control
                  type="file"
                  accept="image/*"
                  onChange={(e) =>
                    e.target.files?.[0] && handleFileUpload('image', e.target.files[0])
                  }
                />
                {isUploading && (
                  <div className="text-muted small mt-1">Uploading...</div>
                )}
                {data.image && (
                  <div className="mt-2">
                    <Image src={data.image} thumbnail style={{ maxWidth: "200px" }} />
                  </div>
                )}
              </Form.Group>
            </Col>
          </Row>

          <div className="d-flex justify-content-between align-items-center mb-3">
            <h6>Economic Impacts</h6>
            <Button variant="outline-primary" size="sm" onClick={handleAddEconomicImpact}>
              Add Impact
            </Button>
          </div>

          {data.economicImpacts.map((impact, index) => (
            <div key={index} className="border rounded p-3 mb-3 bg-light-subtle">
              <Row>
                <Col md={12}>
                  <Form.Control
                    className="mb-2"
                    type="text"
                    placeholder="Impact title"
                    value={impact.title}
                    onChange={(e) => handleEconomicImpactsChange(index, 'title', e.target.value)}
                  />
                </Col>
                <Col md={12}>
                  <Form.Control
                    as="textarea"
                    rows={2}
                    placeholder="Impact description"
                    value={impact.description}
                    onChange={(e) => handleEconomicImpactsChange(index, 'description', e.target.value)}
                  />
                </Col>
                <Col md={12} className="text-end mt-2">
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={() => handleRemoveEconomicImpact(index)}
                  >
                    Remove
                  </Button>
                </Col>
              </Row>
            </div>
          ))}
        </Card.Body>
      )}
    </Card>
  );
};

export default MagnificentPunjabSection;
